<template>
  <div class="box">
    <div class="media-content">
      <div class="content">
        <div class="columns">
          <div class="column">

            <b-field label="Ingrese su monto">
              <b-input v-model="quantity" type="number" placeholder="Ingrese una cantidad" rounded></b-input>
            </b-field>

          </div>
          <div class="column">
            <button class="button is-primary is-medium"
            @click="open(quantity)">
            Consultar
          </button>
        </div>
      </div>
      <div class="columns">
        <div class="column">

          <nav class="level">
            <div class="level-item has-text-centered">
              <div>
                <p class="heading">Total a Pagar</p>
                <p class="title">{{ total }}</p>
              </div>
            </div>

          </nav>
        </div>
      </div>

    </div>
    <nav class="level is-mobile">
      <div class="level-left">
        <a class="level-item">
          <span class="icon is-small"><i class="fas fa-reply"></i></span>
        </a>
        <a class="level-item">
          <span class="icon is-small"><i class="fas fa-retweet"></i></span>
        </a>
        <a class="level-item">
          <span class="icon is-small"><i class="fas fa-heart"></i></span>
        </a>
      </div>
    </nav>
  </div>

</div>

</template>

<script>

import axios from 'axios';
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      quantity: '',
      total: ''
    }
  },

  methods: {
    open(quantity) {

      const loadingComponent = this.$loading.open()

      setTimeout(() => loadingComponent.close(), 1 * 500)
      //Número ingresado por 40% entre 100 esto me devuelve la cantidad que puede sacar la persona
      let percentage = quantity * 40 / 100

      const totalCount = parseInt(quantity) - parseInt(percentage)

      this.total = totalCount
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/credits/NoFees.vue